var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(1 1)","fillRule":"nonzero","stroke":"currentColor"},[React.createElement("circle",{"cx":"4","cy":"4","r":"4","strokeWidth":"1.5","key":0}),React.createElement("path",{"transform":"translate(8.1377 8.1377) rotate(45) translate(-8.1377 -8.1377)","d":"m6.3043 7.8519c-0.1578 0-0.28571 0.12792-0.28571 0.28571 0 0.1578 0.12792 0.28571 0.28571 0.28571h3.6667c0.1578 0 0.28571-0.12792 0.28571-0.28571 0-0.1578-0.12792-0.28571-0.28571-0.28571h-3.6667z","key":1})])));
}

Search.defaultProps = {"version":"1.1","viewBox":"0 0 12 12"};

module.exports = Search;

Search.default = Search;
